// components/layout/SearchCommand.tsx
"use client";

import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";

const MOCK_SEARCH_ITEMS = [
  {
    group: "محصولات",
    items: ["پودر قهوه کلاسنو", "شیر پرچرب کاله", "تخم مرغ توتک"],
  },
  {
    group: "سفارشات",
    items: ["KH-1403-45821", "KH-1403-45830", "KH-1403-45790"],
  },
  { group: "کاربران", items: ["علی محمدی", "سارا احمدی", "رضا کریمی"] },
];

export function SearchCommand() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, []);

  return (
    <>
      {/* دکمه جستجو (دسکتاپ) */}
      <Button
        variant="ghost"
        onClick={() => setOpen(true)}
        className="hidden md:flex items-center gap-3 w-64 justify-between bg-brand-50/60 hover:bg-brand-50 text-muted-foreground hover:text-foreground font-normal rounded-lg px-3 transition-colors"
      >
        <div className="flex items-center gap-2">
          <Search className="h-4 w-4" />
          <span className="text-sm">جستجو...</span>
        </div>
      </Button>

      {/* دکمه جستجو (موبایل) */}
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setOpen(true)}
        className="md:hidden text-muted-foreground hover:text-foreground"
        aria-label="جستجو"
      >
        <Search className="h-5 w-5" />
      </Button>

      {/* Command Dialog */}
      <CommandDialog open={open} onOpenChange={setOpen}>
        <CommandInput placeholder="جستجو در محصولات، سفارشات، کاربران..." />
        <CommandList>
          <CommandEmpty>نتیجه‌ای یافت نشد.</CommandEmpty>
          {MOCK_SEARCH_ITEMS.map((group) => (
            <CommandGroup key={group.group} heading={group.group}>
              {group.items.map((item) => (
                <CommandItem key={item}>{item}</CommandItem>
              ))}
            </CommandGroup>
          ))}
        </CommandList>
      </CommandDialog>
    </>
  );
}